import { FC, ReactNode } from "react";
import classNames from "classnames";

export interface BoxLineProps {
  variant?: "title" | "default";
  size?: "small" | "x-large";
  label: ReactNode;
  value?: ReactNode;
  divider?: boolean;
}
const BoxLine: FC<BoxLineProps> = ({
  variant = "default",
  size = "small",
  label,
  value,
  divider = false,
}) => {
  const style = {
    default: {
      wrapper: "text-foreground/40",
      price: "font-medium",
    },
    title: {
      wrapper: "text-foreground font-medium",
    },
  }[variant];
  const sizeStyle = {
    small: "text-sm",
    "x-large": "text-xl",
  }[size];
  return (
    <p
      className={classNames(
        "flex items-center justify-between space-x-2",
        divider && "border-b border-foreground/5 pb-3 !mb-3",
        sizeStyle,
        style?.wrapper
      )}
    >
      <span>{label}</span>
      {value && <span className={style?.price}>{value}</span>}
    </p>
  );
};

interface BoxLinesProps {
  lines?: BoxLineProps[];
}
const BoxLines: FC<BoxLinesProps> = ({ lines }) => (
  <div className="space-y-1 rounded-lg p-4 bg-foreground/5">
    {lines?.map((item, index) => (
      <BoxLine key={`box-line-${item.label}-${index}`} {...item} />
    ))}
  </div>
);

export default BoxLines;
